import {AbstractModel} from '../abstract-model';
import {Partner} from '../partner';
import {Currency} from '../currency';

export abstract class AbstractBilling extends AbstractModel {
  id: number | null = null;
  partner: Partner | null = null;
  partnerId: number | null = null;
  startingAt: Date | null = null;
  endingAt: Date | null = null;
  totalAmount: number = 0;
  totalVatAmount: number = 0;
  partnerAccountType: string | null = null;
  partnerName: string | null = null;
  paymentThreshold: number | null = null;
  paymentTerms: string | null = null;
  paymentCurrency: Currency | null = null;
  updatedAt: Date | null = null;
  createdAt: Date | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    return this;
  }

  getAmountTaxExcl(): number {
    return this.totalAmount - this.totalVatAmount;
  }

  getVatPercent(): number {
    return this.totalVatAmount / this.getAmountTaxExcl() * 100;
  }
}
